var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.7867 19.32L24.4533 17.1067C24.1733 16.6134 23.92 15.68 23.92 15.1334V11.76C23.92 7.41337 20.3867 3.8667 16.0267 3.8667C11.6667 3.8667 8.13333 7.41337 8.13333 11.76V15.1334C8.13333 15.68 7.87999 16.6134 7.59999 17.0934L6.25333 19.32C5.72 20.2134 5.59999 21.2 5.93333 22.1067C6.25333 23 7.01333 23.6934 7.99999 24.0267C10.5867 24.9067 13.3067 25.3334 16.0267 25.3334C18.7467 25.3334 21.4667 24.9067 24.0533 24.04C24.9867 23.7334 25.7067 23.0267 26.0533 22.1067C26.4 21.1867 26.3067 20.1734 25.7867 19.32Z",
    fill: "#DCDBE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19 4.42675C18.08 4.06675 17.08 3.86675 16.0267 3.86675C14.9867 3.86675 13.9867 4.05341 13.0667 4.42675C13.64 3.34675 14.7733 2.66675 16.0267 2.66675C17.2933 2.66675 18.4133 3.34675 19 4.42675Z",
    fill: "#DCDBE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.7733 26.6801C19.2133 28.2267 17.7333 29.3334 16 29.3334C14.9467 29.3334 13.9067 28.9067 13.1733 28.1467C12.7467 27.7467 12.4267 27.2134 12.24 26.6667C12.4133 26.6934 12.5867 26.7067 12.7733 26.7334C13.08 26.7734 13.4 26.8134 13.72 26.8401C14.48 26.9067 15.2533 26.9467 16.0267 26.9467C16.7867 26.9467 17.5467 26.9067 18.2933 26.8401C18.5733 26.8134 18.8533 26.8001 19.12 26.7601C19.3333 26.7334 19.5467 26.7067 19.7733 26.6801Z",
    fill: "#DCDBE7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.19c80586b5dc40d87168b8c80701cad1.svg";
export { ForwardRef as ReactComponent };